import { render, staticRenderFns } from "./TruckHeader.vue?vue&type=template&id=6fd23581&scoped=true"
import script from "./TruckHeader.vue?vue&type=script&lang=ts"
export * from "./TruckHeader.vue?vue&type=script&lang=ts"
import style0 from "./TruckHeader.vue?vue&type=style&index=0&id=6fd23581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd23581",
  null
  
)

export default component.exports